/** Anonymous Supabase sessions do not qualify for account AI credits. */
export function aiAccountId(user: { id: string; is_anonymous?: boolean } | null | undefined): string | null {
  return user && !user.is_anonymous ? user.id : null;
}
